<template>
  <v-container fluid grid-list-md>
    <p v-if="!hasHistory">Нет истории для отображения</p>
    <v-data-table
      v-if="hasHistory"
      :items="trialHistory"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
    >
      <template v-slot:headers="props">
        <tr>
          <th>Дата</th>
          <th>Роль</th>
          <th>Автор</th>
          <th>Действие</th>
          <th>Статус</th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td class="no-wrap">{{ getDateTime(props.item.date_created) }}</td>
          <td>{{ props.item.role }}</td>
          <td class="no-wrap">{{ getUserFullName(props.item.user) }}</td>
          <td>{{ getActionText(props.item.action) }}</td>
          <td>{{ props.item.status }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import TrialHistory from '@/orm/models/TrialHistory';
import { getUserFullName, getDateTime } from '@/utils';

export default {
  name: 'history',
  props: {
    trial_id: {
      type: [String, Number],
      require: true,
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    permissions: Object,
  },
  data() {
    return {
      trialHistory: JSON.parse(JSON.stringify(TrialHistory.all())),

      rowsPerPageItems: [
        10,
        { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    hasHistory() {
      return this.trialHistory.length > 0;
    }
  },
  methods: {
    getUserFullName,
    getDateTime,
    getActionText(action) {
      return {
        'TRIAL_CREATED': 'Трайл создан',
        'STATUS_CHANGED': 'Изменен статус',
        'TEAM_STATUS_CHANGED': 'Изменен статус команды',
        'FILE_ATTACHED': 'Приложен файл',
        'ADDED_COMMENT': 'Добавлен комментарий',
      }[action];
    },
  }
};
</script>

<style scoped>
</style>
